function updateVideoSources() {
    document.querySelectorAll('video').forEach(video => {
        video.poster = video.getAttribute('data-poster');
    });
}

// Handle Video Poster LazyLoading
window.addEventListener("load", function() {
    const videos = document.querySelectorAll("video");

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                updateVideoSources();
                observer.unobserve(entry.target);
            }
        });
    });

    videos.forEach(container => {
        observer.observe(container);
    });
});
